import Pagination from 'react-bootstrap/Pagination';

const CustomPagination = ({ currentPage, totalPages, handlePageChange }) => {
  const renderPaginationItems = () => {
    const paginationItems = [];

    paginationItems.push(
      <Pagination.Prev
        key="prev"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
    );

    paginationItems.push(
      <Pagination.Item
        key={1}
        active={1 === currentPage}
        onClick={() => handlePageChange(1)}
        className={1 === currentPage ? 'active-page' : ''}
      >
        {1}
      </Pagination.Item>
    );

    if (currentPage > 3) {
      paginationItems.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
    }

    for (
      let i = Math.max(2, currentPage - 2);
      i <= Math.min(totalPages - 1, currentPage + 2);
      i++
    ) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
          className={i === currentPage ? 'active-page' : ''}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (currentPage < totalPages - 2) {
      paginationItems.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
    }

    if (totalPages > 1) {
      paginationItems.push(
        <Pagination.Item
          key={totalPages}
          active={totalPages === currentPage}
          onClick={() => handlePageChange(totalPages)}
          className={totalPages === currentPage ? 'active-page' : ''}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    paginationItems.push(
      <Pagination.Next
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    );

    return paginationItems;
  };

  return (
    <div>
      <style type="text/css">
        {`
          .active-page .page-link {
            background-color: #008B8B !important;
            border-color: #008B8B !important;
            color: white !important;
          }
        `}
      </style>
      <Pagination>{renderPaginationItems()}</Pagination>
    </div>
  );
};

export default CustomPagination;
